import React from 'react'
import { Box, Grid, Image } from '@chatterbug/aaron'

import Action from 'src/ui/Action/Action'

export type Props = {
  message: string
  iconUrl?: string
  link?: {
    url: string
    label: string
  }
}

const SideNote: React.FC<Props> = ({ message, iconUrl, link }) => {
  return (
    <Box
      p="3x"
      borderRadius="0,5x"
      borderWidth={1}
      borderStyle="solid"
      borderColor="yellow65"
      bg="yellow92"
    >
      <Grid
        gap={{ _: '1x', tablet: '2x' }}
        columns={iconUrl ? { _: '1fr', tablet: 'auto 1fr' } : '1fr'}
        textAlign={{
          _: 'center',
          tablet: 'left',
        }}
      >
        {iconUrl && (
          <Box>
            <Image src={iconUrl} width={64} height={64} alt="" />
          </Box>
        )}
        <Box>
          <Box
            as="p"
            variant="text.paragraph"
            color="black19"
            textAlign="left"
            dangerouslySetInnerHTML={{ __html: message }}
          />
          {link && (
            <Box mt="3x" ml={{ tablet: '-8px' }}>
              <Action href={link.url}>{link.label}</Action>
            </Box>
          )}
        </Box>
      </Grid>
    </Box>
  )
}

export default SideNote
